import { useEffect, useState } from "react"
import Translation from "./Translation"
import { useLocation } from "react-router-dom"
import LoadingIcon from "../components/icon/LoadingIcon"


export default () => {

    const [docId, setDocId] = useState<string>()
    const location = useLocation()

    useEffect(() => {
        const _docId = location.search.split("docId=")[1]
        setDocId(_docId)
    }, [location])

    if(!docId){
        return <div style={{padding: 16}}><LoadingIcon/></div>
    }
    return <Translation docId={docId} />

    
}